<script>
import { createEventDispatcher, onMount } from 'svelte';
import { fade } from 'svelte/transition';
import { cubicOut } from 'svelte/easing';

export let nofocus;
export let size = ''; // small, large
export let title = '';
export let noClose = false;
let className = '';
export { className as class };

const dispatch = createEventDispatcher();
let container;


export function close() {
  dispatch('close');
}

onMount(() => {
  document.body.appendChild(container);
  if (!nofocus) container.focus();
});


function settle(node) {
  return {
    easing: cubicOut,
    delay: 150,
    duration: 150,
    css: (t, rt) => `transform: translate(0, -${rt*25}px); opacity: ${t}`
  }
}
</script>

<div bind:this={container} class="modal-container{size ? ' ' + size : ''} {className}" tabindex="-1" role="dialog">
  <div class="modal-background" on:click={close} transition:fade|local={{ duration: 300 }}></div>
  <div class="modal-dialog" role="document" transition:settle|local>
    <div class="modal-content">
      {#if title}
      <header>
        <h2>{title}</h2>
      </header>
      {/if}
      <slot>
        <section></section>
        <footer></footer>
      </slot>
      {#if !noClose}
      <button class="icon icon-close" on:click={close}></button>
      {/if}
    </div>
  </div>
</div>

<svelte:window on:keydown={event => event.key === 'Escape' && close()}/>

<style>
.icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 30px;
}
.modal-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  -webkit-overflow-scrolling: touch;
}
.modal-container > .modal-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
}
.modal-container > .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
  background-color: #fff;
  background-clip: padding-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  outline: 0;
  padding: 10px;
}
.modal-dialog header {
  padding: 16px;
  border-bottom: 4px solid var(--yellow-500);
}
.modal-dialog header::before,
.modal-dialog :global(footer::before) {
  display: table;
  content: " ";
}
.modal-dialog header::after,
.modal-dialog :global(footer::after) {
  display: table;
  content: " ";
  clear: both;
}
.modal-dialog header :global(h2),
.modal-dialog header :global(h3),
.modal-dialog header :global(h4) {
  color: var(--warm-grey-600);
  margin: 0;
}
.modal-dialog :global(section) {
  position: relative;
  padding: 16px;
}
.modal-dialog :global(section > :global(:first-child)) {
  margin-top: 0;
}
.modal-dialog :global(section > :global(:last-child)) {
  margin-bottom: 0;
}
.modal-dialog :global(footer) {
  padding: 16px;
  text-align: right;
}
.modal-dialog :global(footer > :global(:not(:last-child))) {
  margin-right: .25rem;
}
.modal-dialog :global(footer > :global(:not(:first-child))) {
  margin-left: .25rem;
}
.modal-dialog :global(footer > :global(.left)) {
  float: left;
}
@media (min-width: 544px) {
  .modal-container > .modal-dialog {
    max-width: 600px;
    margin: 80px auto;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
  }
  .modal-container.small > .modal-dialog {
    max-width: 400px;
  }
}
@media (min-width: 992px) {
  .modal-container.large > .modal-dialog {
    max-width: 900px;
  }
}
</style>
